<template>
  <div>
    <img src="https://zbhk.lnyun.com.cn/www/huanren/images/202401/1746759697022550017.jpg" style="width: 100%;">
  </div>

</template>

<script>
export default {
  name: "HeaderImgYjj"
}
</script>

<style scoped>

</style>
